const countries = {
  countries: {
    AD: "Andorra",
    AE: "Vereinigte Arabische Emirate",
    AL: "Albanien",
    AO: "Angola",
    AR: "Argentinien",
    AT: "Österreich",
    AU: "Australien",
    BA: "Bosnien und Herzegowina",
    BD: "Bangladesch",
    BE: "Belgien",
    BF: "Burkina Faso",
    BG: "Bulgarien",
    BI: "Burundi",
    BJ: "Benin",
    BZ: "Belize",
    BO: "Bolivien",
    BR: "Brasilien",
    BW: "Botswana",
    BY: "Belarus",
    CA: "Kanada",
    CH: "Schweiz",
    CI: "Côte d’Ivoire",
    CL: "Chile",
    CM: "Kamerun",
    CN: "China",
    CO: "Kolumbien",
    CR: "Costa Rica",
    CY: "Zypern",
    CZ: "Tschechien",
    DE: "Deutschland",
    DK: "Dänemark",
    DO: "Dominikanische Republik",
    DZ: "Algerien",
    EC: "Ecuador",
    EE: "Estland",
    EG: "Ägypten",
    ES: "Spanien",
    ET: "Äthiopien",
    FI: "Finnland",
    FJ: "Fidschi",
    FM: "Föderierte Staaten von Mikronesien",
    FR: "Frankreich",
    GB: "Vereinigtes Königreich",
    GE: "Georgien",
    GH: "Ghana",
    GR: "Griechenland",
    GT: "Guatemala",
    GY: "Guyana",
    HK: "Hongkong",
    HN: "Honduras",
    HR: "Kroatien",
    HU: "Ungarn",
    ID: "Indonesien",
    IE: "Irland",
    IL: "Israel",
    IN: "Indien",
    IQ: "Irak",
    IR: "Iran",
    IS: "Island",
    IT: "Italien",
    JO: "Jordanien",
    JP: "Japan",
    KE: "Kenia",
    KH: "Kambodscha",
    KI: "Kiribati",
    KR: "Südkorea",
    KW: "Kuwait",
    KZ: "Kasachstan",
    LA: "Laos",
    LB: "Libanon",
    LI: "Liechtenstein",
    LK: "Sri Lanka",
    LS: "Lesotho",
    LT: "Litauen",
    LU: "Luxemburg",
    LV: "Lettland",
    LY: "Libyen",
    MA: "Marokko",
    MC: "Monaco",
    MD: "Moldau",
    ME: "Montenegro",
    MG: "Madagaskar",
    MH: "Marshallinseln",
    MK: "Nordmazedonien",
    ML: "Mali",
    MM: "Myanmar",
    MN: "Mongolei",
    MT: "Malta",
    MU: "Mauritius",
    MW: "Malawi",
    MX: "Mexiko",
    MY: "Malaysia",
    MZ: "Mosambik",
    NA: "Namibia",
    NE: "Niger",
    NG: "Nigeria",
    NI: "Nicaragua",
    NL: "Niederlande",
    NO: "Norwegen",
    NP: "Nepal",
    NR: "Nauru",
    NZ: "Neuseeland",
    OM: "Oman",
    PA: "Panama",
    PE: "Peru",
    PG: "Papua-Neuguinea",
    PH: "Philippinen",
    PK: "Pakistan",
    PL: "Polen",
    PT: "Portugal",
    PW: "Palau",
    PY: "Paraguay",
    QA: "Katar",
    RO: "Rumänien",
    RS: "Serbien",
    RW: "Ruanda",
    SA: "Saudi-Arabien",
    SB: "Salomonen",
    SC: "Seychellen",
    SD: "Sudan",
    SE: "Schweden",
    SG: "Singapur",
    SI: "Slowenien",
    SK: "Slowakei",
    SL: "Sierra Leone",
    SM: "San Marino",
    SN: "Senegal",
    SR: "Suriname",
    SV: "El Salvador",
    SZ: "Eswatini",
    TD: "Tschad",
    TG: "Togo",
    TH: "Thailand",
    TN: "Tunesien",
    TO: "Tonga",
    TR: "Türkei",
    TV: "Tuvalu",
    TW: "Taiwan",
    TZ: "Tansania",
    UA: "Ukraine",
    UG: "Uganda",
    US: "Vereinigte Staaten",
    UY: "Uruguay",
    UZ: "Usbekistan",
    VA: "Vatikanstadt",
    VE: "Venezuela",
    VN: "Vietnam",
    VU: "Vanuatu",
    WS: "Samoa",
    XK: "Kosovo",
    YE: "Jemen",
    ZA: "Südafrika",
    ZM: "Sambia",
    ZW: "Simbabwe",
  },
} as const;

export default countries;
